import { gql, useQuery } from '@apollo/client';

export const GET_APPLICATIONS_SETTING = gql`
  query getAllCompanyApplicationsSetting($companyId: String!) {
    getAllCompanyApplicationsSetting(companyId: $companyId) {
      type
      email
      _id
      companyId
      eAUTemplateAcceptedId
      eAUTemplateId
      eAUTemplateRejectedId
      rejectReasons {
        reason
        rejectValue
      }
      eAUTemplate {
        subject
      }
      eAUTemplateRejected {
        subject
      }
      eAUTemplateAccepted {
        subject
      }
    }
  }
`;

export const useGetApplicationsSetting = (companyId?: string) => {
  const { data, loading } = useQuery(GET_APPLICATIONS_SETTING, {
    variables: { companyId },
    skip: !companyId,
  });

  const applicationsSettings = data?.getAllCompanyApplicationsSetting || [];

  return { applicationsSettings, loading };
};
